import { Icon } from "../../components/ui/Icon";
import { cx } from "../../components/ui/cx";

/** Desktop or Phone: how the page is seen. */
export function ViewSeg({ phone, onPhone }: { phone: boolean; onPhone: (phone: boolean) => void }) {
  return (
    <div className="seg bw-view" role="radiogroup" aria-label="See it on">
      <button type="button" role="radio" aria-checked={!phone} className={cx(!phone && "on")} onClick={() => onPhone(false)}>
        <Icon name="monitor" />
        Desktop
      </button>
      <button type="button" role="radio" aria-checked={phone} className={cx(phone && "on")} onClick={() => onPhone(true)}>
        <Icon name="phone" />
        Phone
      </button>
    </div>
  );
}
